import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_RESEND,
  FORGET_PASSWORD_UPDATE,
  FORGET_PASSWORD_UPDATE_SUCCESS,
  FORGET_PASSWORD_UPDATE_ERROR,
  FORGOT_PASSWORD_RESET,
  RESET_FORGOT_PSWD_RESPONSE_MSG
} from "./actionTypes"

const initialState = {
  forgotPasswordError: false,
  forgotPasswordErrorMessage: null,
  message: null,
  loading: false,
  user: null,
  linkSend: false,
  passwordUpdate: false,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        loading: true,
      }
      break
    case FORGET_PASSWORD_RESEND:
      state = {
        ...state,
        loading: true,
      }
      break

    case FORGET_PASSWORD_UPDATE: {
      state = {
        ...state,
        loading: true,
      }
      break
    }
    case FORGET_PASSWORD_UPDATE_SUCCESS: {
      state = {
        ...state,
        forgotPasswordError: false,
        forgotPasswordErrorMessage: null,
        passwordUpdate: true,
        message: null,
        loading: false,
        user: null,
      }
      break
    }
    case FORGET_PASSWORD_UPDATE_ERROR: {
      state = {
        ...state,
        forgotPasswordError: true,
        forgotPasswordErrorMessage: action.payload,
        message: null,
        loading: false,
        user: null,
      }
      break
    }
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgotPasswordErrorMessage: action.payload.responseMessage,
        user: action.payload.user,
        forgotPasswordError: false,
        linkSend: true,
        loading: false,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = {
        ...state,
        forgotPasswordError: true,
        forgotPasswordErrorMessage: action.payload,
        loading: false,
      }
      break
    case FORGOT_PASSWORD_RESET:
      state = {
        forgotPasswordError: false,
        forgotPasswordErrorMessage: null,
        message: null,
        loading: false,
        user: null,
        linkSend: false,
        passwordUpdate: false,
      }
      break
    case RESET_FORGOT_PSWD_RESPONSE_MSG:
      state = {
        ...state,
        forgotPasswordError: false,
        forgotPasswordErrorMessage: null,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
